import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import Form from './FormDetailContainer';
import { closeCompleteProfilePopUp } from './action';
//Style
import './style.scss';

class FirtJointEventProfileForm extends Component {
  render() {
    return (
      <Modal
        backdrop='static'
        id="first-joint-event"
        keyboard={false}
        show={this.props.show}
        onHide={this.props.onHide}
      >
        <Modal.Header>
          <Modal.Title>初期設定</Modal.Title>
          <img alt="" src="./images/Quit.svg" onClick={this.props.onHide} />
        </Modal.Header>
        <Modal.Body>
          <Form />
        </Modal.Body>
      </Modal>
    );
  }
}

FirtJointEventProfileForm.propTypes = {
  onHide: PropTypes.func,
  show: PropTypes.bool
};

const mapStateToProps = (state) => ({
  show: state.get('requestCompleteProfile').get('show')
});

const mapDispatchToProps = (dispatch) => ({
  onHide: () => dispatch(closeCompleteProfilePopUp())
});

export default connect(mapStateToProps, mapDispatchToProps)(FirtJointEventProfileForm);
